import React from "react";
interface CardInfoProps {
  nome?: string | number,
  valor?: string | number,
  valorN?: string,
  acuracia?: string | number,
  top?: string | number,
};

const CardInfo: React.FC<CardInfoProps> = ({ nome, valor, valorN, acuracia, top }) => {
  // Primeiro Valor deve ser 2 digitos decimais
  // Segundo Valor deve ser @ com numero INTEIRO
  // Terceiro valor deve ser esse ®️ com numero inteiro e %

  return (
    <div className="cards-info--item">
      <div className="cards-info-header">
        <p>{nome || ''}</p>
      </div>
      <div className="cards-info-body">
        {
          valorN !== undefined
            ? <p>{valorN || 0}</p>
            : <>
              <p>{valor ? String(valor) : '---'}</p>

              <p>{acuracia ? `@ ${String(acuracia)}` : '---'}</p>

              <p>{top ? `® ${String(top)}%` : '---'}</p>
            </>
        }
      </div>
    </div>
  );
}

export default CardInfo;